/**
 * API client for brand listing (brand switcher).
 */

import type { Brand } from '@provendoro/shared/types'

interface ApiResponse<T> {
  data?: T
  error?: { message: string; code: string }
}

async function adminFetch<T>(
  url: string,
  options?: RequestInit,
): Promise<ApiResponse<T>> {
  const response = await fetch(url, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
  return response.json() as Promise<ApiResponse<T>>
}

export async function getBrands(): Promise<ApiResponse<Brand[]>> {
  return adminFetch('/api/v1/admin/brands')
}
